import Config from '../../../../config';
import FetchApi from '../../../../core/fetch/FetchApi';
import generateValidUrl from '../../../../core/fetch/generateValidUrl';
import { HttpMethods } from '../../../../core/fetch/HttpMethod';
import formatRequestBody from '../../../../temp/formatRequestBody';
import { IPwaPushApiResult, ISubscribePwaPushRequest } from '../types';
import { parsePwaPushResponse } from '../utils/parsePwaPushResponse';

export interface ISubscribePwaPushDeps {
    fetchFn?: typeof FetchApi.fetch;
}

export async function subscribePwaPush(
    request: ISubscribePwaPushRequest,
    deps: ISubscribePwaPushDeps = {}
): Promise<IPwaPushApiResult> {
    const fetchFn = deps.fetchFn ?? FetchApi.fetch.bind(FetchApi);

    try {
        const response = await fetchFn(
            generateValidUrl(Config.BASE_URL),
            formatRequestBody(Config.SET_PWA_SUBSCRIBE_URL, request.user.Userid, {
                endpoint: request.subscription.endpoint,
                p256dh: request.subscription.p256dh,
                auth: request.subscription.auth,
                userAgent: request.subscription.userAgent || '',
            }),
            HttpMethods.POST,
            request.token,
            request.user
        );

        const payload = await response.json();
        return parsePwaPushResponse(payload, 'subscribed');
    } catch {
        return { status: 'error', note: 'NetworkError' };
    }
}
